(() => {
  let ajaxinate;

  function initializeInfiniteScroll() {
    if (ajaxinate) {
      ajaxinate.destroy();
      ajaxinate = null;
    }

    const container = document.querySelector('#product-grid');
    const pagination = document.querySelector('.pagination-wrapper--infinite .infinite_next');

    if (!container || !pagination || typeof Ajaxinate !== 'function') return;

    ajaxinate = new Ajaxinate({
      container: '#product-grid',
      pagination: '.pagination-wrapper--infinite .infinite_next',
      callback() {
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(container);
        }
      },
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeInfiniteScroll, { once: true });
  } else {
    initializeInfiniteScroll();
  }

  document.addEventListener('heroes-cave:grid-updated', initializeInfiniteScroll);
  document.addEventListener('shopify:section:load', initializeInfiniteScroll);
})();
